// Enhance native disclosure panels; without JavaScript every panel stays accessible.
if (!customElements.get('wolff-product-details')) {
  customElements.define('wolff-product-details', class extends HTMLElement {
    connectedCallback() {
      if (this.tabs) return;
      this.extractDimensions();
      const panels = [...this.querySelectorAll(':scope > details')];
      if (panels.length < 2) return;
      this.tabs = document.createElement('div');
      this.tabs.className = 'wolff-product__tabs';
      this.tabs.setAttribute('role', 'tablist');
      this.tabs.setAttribute('aria-label', this.dataset.informationLabel || 'Product information');
      this.panels = [];
      this.buttons = panels.map((disclosure, index) => {
        const summary = disclosure.querySelector('summary');
        const panel = document.createElement('div');
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = summary.textContent;
        button.id = `WolffTab-${this.dataset.section}-${index}`;
        button.setAttribute('role', 'tab');
        panel.id = `WolffPanel-${this.dataset.section}-${index}`;
        button.setAttribute('aria-controls', panel.id);
        panel.setAttribute('aria-labelledby', button.id);
        panel.setAttribute('role', 'tabpanel');
        panel.tabIndex = 0;
        panel.append(...[...disclosure.children].filter(child => child !== summary));
        disclosure.replaceWith(panel);
        this.panels.push(panel);
        button.addEventListener('click', () => this.select(index));
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % panels.length;
          if (event.key === 'ArrowLeft') next = (index + panels.length - 1) % panels.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = panels.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.select(next);
          this.buttons[next].focus();
        });
        this.tabs.append(button);
        return button;
      });
      this.prepend(this.tabs);
      this.classList.add('is-enhanced');
      this.select(0);
    }
    extractDimensions() {
      if (this.dataset.productContext !== 'interior' || this.querySelector(':scope > details[data-dimensions]')) return;
      const description = this.querySelector(':scope > details[data-description]');
      const content = description?.querySelector('.wolff-product__detail-content');
      if (!content) return;
      // Move only an explicitly labelled, structured measurements block. Leave
      // unrecognised descriptions intact, including the no-JavaScript fallback.
      const heading = [...content.querySelectorAll('h2,h3,h4,h5,h6,p')].find(el => /^(ölçüler|ürün ölçüleri|dimensions|measurements|afmetingen|maße|abmessungen)(\s*\((cm|mm|m|in|inches)\))?\s*:?$/iu.test(el.textContent.trim()));
      const inlineHeading = heading ? null : [...content.querySelectorAll('h2,h3,h4,h5,h6,p')].find(el => /^(dimensions|measurements|afmetingen|maße|abmessungen)\s*(\((cm|mm|m|in|inches)\))?\s*:\s*.*\d/iu.test(el.textContent.trim()));
      const dimensionHeading = heading || inlineHeading;
      if (!dimensionHeading) return;
      const measurements = inlineHeading ? [inlineHeading] : [];
      let node = dimensionHeading.nextElementSibling;
      if (node?.matches('ul,ol,table')) measurements.push(node);
      else while (node?.matches('p') && /^(genişlik|derinlik|yükseklik|oturma yüksekliği|width|depth|height|seat height|seating\s+hight|seating\s+height|breedte|diepte|hoogte|breite|tiefe|höhe|sitzhöhe)(\s*\((cm|mm|m|in|inches)\))?\s*:/iu.test(node.textContent.trim())) {
        measurements.push(node);
        node = node.nextElementSibling;
      }
      if (!measurements.length) return;
      const details = document.createElement('details');
      details.dataset.dimensions = '';
      const summary = document.createElement('summary');
      summary.textContent = this.dataset.dimensionsLabel || 'Dimensions';
      const body = document.createElement('div');
      body.className = 'wolff-product__detail-content rte';
      body.append(...measurements);
      details.append(summary, body);
      const precedingPanel = this.querySelector(':scope > details[data-features]') || description;
      precedingPanel.after(details);
      if (heading) heading.remove();
    }
    select(index) {
      this.buttons.forEach((button, i) => {
        button.setAttribute('aria-selected', i === index ? 'true' : 'false');
        button.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
    }
  });
}
